import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// namespaces
import { GetTranslationFunction } from 'ts/translation';
import { en_namespaces } from './en/namespaces';
import { ar_namespaces } from './ar/namespaces';

export const defaultNS = 'common';
export const resources = {
  en: en_namespaces,
  ar: ar_namespaces,
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'app',
      'common',
      'validation',
      'my-gift-cards',
      'dashboard',
      'tutorials',
      'auth',
      'finance',
      'get-started',
      'subscription',
    ],
    fallbackLng: ['en', 'ar'],
    debug: process.env.NODE_ENV !== 'production',

    interpolation: {
      escapeValue: false,
    },
    resources,
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      excludeCacheFor: ['localStorage'],

      // lookupLocalStorage: 'i18nextLng',
      // lookupSessionStorage: 'i18nextLng',
    },
  });

export const t = i18n.t.bind(i18n) as GetTranslationFunction;

export default i18n;
